import { NavLink, Outlet } from "react-router-dom";
import { PlusCircle, ListChecks, Settings as SettingsIcon, Sun, LogOut } from "lucide-react";
import { authEnabled, signOut } from "../lib/session.ts";

const navItems = [
  { to: "/intake", label: "New Job", icon: PlusCircle },
  { to: "/jobs", label: "Jobs", icon: ListChecks },
  { to: "/settings", label: "Settings", icon: SettingsIcon },
];

export function Layout({ email }: { email: string }) {
  return (
    <div className="min-h-full">
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500 text-white">
              <Sun size={20} />
            </span>
            <div className="leading-tight">
              <div className="text-sm font-bold text-slate-900">Solar R&amp;R</div>
              <div className="text-xs text-slate-500">Job Automation</div>
            </div>
          </div>
          <nav className="flex items-center gap-1">
            {navItems.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-brand-50 text-brand-700"
                      : "text-slate-600 hover:bg-slate-100"
                  }`
                }
              >
                <Icon size={16} />
                <span className="hidden sm:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <span className="hidden text-xs text-slate-500 md:inline">{email}</span>
            {authEnabled && (
              <button
                onClick={() => signOut().then(() => window.location.reload())}
                className="btn-ghost"
                title="Sign out"
              >
                <LogOut size={16} />
              </button>
            )}
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
